import type { BookingDetailsState } from '../../domain/types'

export type TransferCardsAlignment = 'full' | 'header' | null

export function getTransferCardsAlignment(state: BookingDetailsState): TransferCardsAlignment {
  const { outbound, inbound } = state.transfers

  if (!outbound || !inbound)
    return null

  return outbound.pickupLocation ? 'full' : 'header'
}
